import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import { OnyxDatePipe } from '@onyx/angular';
import type { DriverIdentityDocument } from '../../../../dashboard/drivers/common/interfaces/driver';
import { ColorHelper } from '../../../helpers/color.helper';
import { CountryCellComponent } from '../country-cell/country-cell.component';

@Component({
  selector: 'app-document-cell',
  imports: [
    CountryCellComponent,
    OnyxDatePipe,
    TranslatePipe,
    NgTemplateOutlet,
  ],
  templateUrl: './document-cell.component.html',
  styleUrl: './document-cell.component.scss',
})
export class DocumentCellComponent {
  public readonly document =
    input.required<OnyxOptional<DriverIdentityDocument>>();

  protected cellColor = computed(() =>
    ColorHelper.getCellColor(this.document()?.expirationDate),
  );
}
